import styled from 'styled-components';
import { background } from '../../../config';


export const Wrapper = styled.div`
  width: 100%;
  min-min-height: 100vh;
  padding: 0;
  margin: 0;
  padding-top: 0px;
  background: none;
  background-size: cover;
  background-attachment: fixed;
  padding-bottom: 50px;
  position: relative;
  z-index:100;

  > div.licdiv {
    width: 100%;
    height: 55px;

    position: relative;
    > div.lic {
      height: 55px;
      position: relative;
      color: #ffffff;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: center;
      width: 100%;
      z-index: 99999;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgb(179, 0, 255);
      padding: 10px;

      @media (max-width: 750px) {
        background: rgb(179, 0, 255);
        height: 55px;
        position: relative;
        color: #ffffff;
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: center;
        width: 100%;
        z-index: 99999;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
`;

export const Background = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: url(${background}) no-repeat top left;
  background-size: cover;
  width: 100%;
  min-height: 100vh;
  z-index: -1;
`;
